<template>
  <v-container>
    <menu-header v-if="headerExists"></menu-header>
    <div>
      <v-card>
        <v-card-subtitle>{{ $t("header.title1") }}</v-card-subtitle>
        <v-row class="pa-10">
          <v-col cols="3" sm="3" md="3">
            <v-text-field readonly v-model="editedItem.dprNumber">
              <template v-slot:label>
                {{ $t("header.number") }}
              </template>
            </v-text-field>
          </v-col>
          <v-row class="ml-1">
            <v-col cols="3" sm="6" md="3">
              <v-text-field readonly :value="dateMixin(editedItem.dprDate)" prepend-icon="mdi-calendar">
                <template v-slot:label>
                  {{ $t("header.date") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="3" sm="6" md="3">
              <v-text-field readonly :value="dateMixin(editedItem.issueDate)" prepend-icon="mdi-calendar">
                <template v-slot:label>
                  {{ $t("header.issued") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="2" sm="6" md="2">
              <v-text-field readonly v-model="editedItem.timeStart" v-mask="'##:##'">
                <template v-slot:label>
                  {{ $t("header.startTime") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="2" sm="6" md="2">
              <v-text-field readonly v-model="editedItem.timeEnd" v-mask="'##:##'">
                <template v-slot:label>
                  {{ $t("header.endTime") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="2" sm="6" md="2">
              <v-text-field readonly v-model="editedItem.timeZone">
                <template v-slot:label>
                  {{ $t("header.timeZone") }}
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row class="ml-1">
            <v-col cols="6" sm="6" md="3">
              <v-text-field readonly v-model="editedItem.jobDescription">
                <template v-slot:label>
                  {{ $t("header.job") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field readonly v-model="editedItem.client">
                <template v-slot:label>
                  {{ $t("header.client") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field readonly v-model="editedItem.project">
                <template v-slot:label>
                  {{ $t("header.project") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field readonly v-model="editedItem.projectCode">
                <template v-slot:label>
                  {{ $t("header.pcode") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field readonly v-model="editedItem.vessel">
                <template v-slot:label>
                  {{ $t("header.vessel") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field readonly v-model="editedItem.vesselStatus">
                <template v-slot:label>
                  {{ $t("header.vstatus") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field readonly v-model="editedItem.location">
                <template v-slot:label>
                  {{ $t("header.location") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field readonly v-model="editedItem.partiesInvolved">
                <template v-slot:label>
                  {{ $t("header.parties") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field readonly v-model="editedItem.author">
                <template v-slot:label>
                  {{ $t("header.author") }}
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-select class="form-control" readonly :items="estimates" item-text="description" item-value="id" v-model="editedItem.estimateId">
                <template v-slot:label>
                  {{ $t("header.estimates") }}
                </template>
              </v-select>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-select class="form-control" :items="yesNoValues" item-text="text" item-value="value" v-model="editedItem.cumulativeDpr" readonly>
                <template v-slot:label>
                  {{ $t("header.cumulative") }}
                </template>
              </v-select>
            </v-col>
            <v-col cols="6" sm="6" md="3">
              <v-text-field v-if="editedItem.cumulativeDpr == 1" readonly :value="dateMixin(editedItem.endDate)" prepend-icon="mdi-calendar">
                <template v-slot:label>
                  {{ $t("header.endDate") }}
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-row>
      </v-card>
      <v-spacer class="mb-4"></v-spacer>
      <v-card>
        <v-card-subtitle>{{ $t("header.title2") }}</v-card-subtitle>
        <v-row align="center" justify="center">
          <v-col class="ml-3" cols="2" sm="2" md="1">
            {{ $t("header.latitude") }}
          </v-col>
          <v-col cols="2" sm="2" md="1">
            <v-text-field readonly v-model="latitude.degrees" type="number"></v-text-field>
          </v-col>
          °
          <v-col cols="2" sm="2" md="1">
            <v-text-field readonly v-model="latitude.minutes" type="number"></v-text-field>
          </v-col>
          '
          <v-col cols="2" sm="2" md="1">
            <v-text-field readonly v-model="latitude.seconds" type="number"></v-text-field>
          </v-col>
          "
          <v-col cols="2" sm="2" md="1">
            <v-select readonly :items="coordinates" v-model="editedItem.latitudeDirect"> </v-select>
          </v-col>
          <v-col class="ml-3" cols="2" sm="2" md="1">
            {{ $t("header.longitude") }}
          </v-col>
          <v-col cols="2" sm="2" md="1">
            <v-text-field readonly v-model="longitude.degrees" type="number"></v-text-field>
          </v-col>
          °
          <v-col cols="2" sm="2" md="1">
            <v-text-field readonly v-model="longitude.minutes" type="number"></v-text-field>
          </v-col>
          '
          <v-col cols="2" sm="2" md="1">
            <v-text-field readonly v-model="longitude.seconds" type="number"></v-text-field>
          </v-col>
          "
          <v-col cols="2" sm="2" md="1">
            <v-select readonly :items="coordinates" v-model="editedItem.longitudeDirect"> </v-select>
          </v-col>
        </v-row>
      </v-card>
    </div>
  </v-container>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import Checks from "./Checks.vue";
import moment from "moment";

export default {
  components: {
    "menu-header": Checks,
  },
  data() {
    return {
      latitude: { degrees: 0, minutes: 0, seconds: 0 },
      longitude: { degrees: 0, minutes: 0, seconds: 0 },
      editedItem: {},
      defaultItem: {},
      reportingPeriod: this.$t("header.reportingPeriod"),
      date: moment()
        .toISOString()
        .substr(0, 10),
      newDprRequested: false,
      currentMainDprId: null,
      currentPVId: null,
      yesNoValues: [
        { text: this.$t("common.yes"), value: true },
        { text: this.$t("common.no"), value: false },
      ],
    };
  },
  computed: {
    ...mapGetters(["mv_dprData/getDprPVId", "mv_dprData/getCurrentDprMainId", "m_estimate/getEstimates", "mv_dprHeader/getCoords", "mv_dprHeader/getDprHeader", "mv_dprHeader/getDprHeaderNo"]),
    estimates() {
      return this["m_estimate/getEstimates"];
    },
    coordinates() {
      return this["mv_dprHeader/getCoords"];
    },
    issuedDate() {
      return moment(this.date, "YYYY-MM-DD")
        .add(1, "days")
        .format("L");
    },
    headerExists() {
      return !this.newDprRequested && this.currentMainDprId ? true : false;
    },
    previousHeader() {
      return this["mv_dprHeader/getDprHeader"];
    },
  },
  created() {
    this.newDprRequested = 1 == parseInt(this.$route.query.ndpr || 0);
    this.currentMainDprId = this.$route.params.dprMainId;
    this.currentPVId = this.$route.params.pvId;

    this.reset();
    this.refreshData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.mHideLongLoader();
    });
  },
  methods: {
    ...mapMutations(["mHideLongLoader", "mv_dprHeader/SET_DPR_HEADER"]),
    ...mapActions(["loadUserContext", "mv_dprHeader/fetchDprHeader", "mv_dprHeader/fetchDprHeaderNo", "mv_dprHeader/fetchCoords", "m_estimate/fetchEstimates"]),

    refreshData() {
      this["m_estimate/fetchEstimates"]({
        pvId: this.currentPVId,
      });
      this["mv_dprHeader/fetchCoords"]();

      // XXXX
      // this.handleProjectVesselData(this.getUserContext.project, this.getUserContext.vessel)

      this.setDefaultItem();
    },

    handleProjectVesselData(project, vessel) {
      this.$log.debug("updating project & vessel data", project, vessel);

      this.editedItem.client = project.client;
      this.editedItem.projectCode = project.projectCode;
      this.editedItem.project = project.projectName;
      this.editedItem.partiesInvolved = project.partiesInvolved;
      this.editedItem.vessel = vessel.description;
    },

    setDefaultItem() {
      this.editedItem.dprDate = this.date;
      this.editedItem.issueDate = this.issuedDate;
      this.editedItem.reportPeriod = this.reportingPeriod;
      this.editedItem.timeStart = "00:00";
      this.editedItem.timeEnd = "00:00";
      this.editedItem.latitudeDirect = "N";
      this.editedItem.longitudeDirect = "N";
      this.editedItem.estimateId = this.estimates[0] ? this.estimates[0].description : "";
    },

    reset() {
      this.$log.debug("resetting DPR header ", this.headerExists, this.newDprRequested);

      if (this.headerExists) {
        this["mv_dprHeader/fetchDprHeader"](this.currentMainDprId).then((dprHeeader) => {
          sessionStorage.currentDprHeader = JSON.stringify(dprHeeader);
          this.editedItem = Object.assign({}, this.previousHeader);

          this.editedItem.timeStart = this.convertToTime(this.editedItem.timeStart);
          this.editedItem.timeEnd = this.convertToTime(this.editedItem.timeEnd);

          if (this.editedItem.longitudeDirect) {
            this.editedItem.longitudeDirect = this.editedItem.longitudeDirect.trim();
          }
          if (this.editedItem.latitudeDirect) {
            this.editedItem.latitudeDirect = this.editedItem.latitudeDirect.trim();
          }

          if (this.editedItem.longitude) {
            this.longitude.degrees = this.editedItem.longitude.split("°")[0];
            this.longitude.minutes = this.editedItem.longitude.split("°")[1].split("'")[0];
            this.longitude.seconds = this.editedItem.longitude
              .split("°")[1]
              .split("'")[1]
              .split('"')[0];
          }

          if (this.editedItem.latitude) {
            this.latitude.degrees = this.editedItem.latitude.split("°")[0];
            this.latitude.minutes = this.editedItem.latitude.split("°")[1].split("'")[0];
            this.latitude.seconds = this.editedItem.latitude
              .split("°")[1]
              .split("'")[1]
              .split('"')[0];
          }
        });
      }

      if (!this.headerExists) {
        this.latitude = { degrees: 0, minutes: 0, seconds: 0 };
        this.longitude = { degrees: 0, minutes: 0, seconds: 0 };

        this.editedItem = Object.assign({}, this.defaultItem);

        // this['mv_dprHeader/fetchDprHeaderNo'](this['mv_dprData/getDprPVId']).then((no) => {
        //   this.editedItem.dprNumber = no
        //   this.$log.debug('updating new header', this.editedItem)
        //   this['mv_dprHeader/SET_DPR_HEADER'](this.editedItem)
        // })
      }
    },

    //#region Utility methods
    /**
     * Converts a C# TimeSpan to a HH:mm format
     *
     * @param timeSpan The C# TimeSpan str format
     */
    convertToTime(timeSpan) {
      if (!timeSpan || "" == timeSpan) {
        return timeSpan;
      }

      const [h, m] = timeSpan.split(":");
      return `${h}:${m}`;
    },
    //#endregion
  },
};
</script>
